import styled from 'styled-components';
import { key } from 'styled-theme';

export default styled.label`
  color: ${key('colors.black.light[300]')};
  font-size: 16px;
  font-weight: 500;
`;
